import React from 'react'
import styled from 'styled-components';
import { device, breakpoints } from '../../../../app/js/utils/responsive_utilities';
import { titanWhite, white, codGrey } from '../../../../app/js/components/loggedout/shared-styles/Colors';
import Image from '../../../../app/js/components/loggedout/common/Image';
import { fontQuicksand } from '../../common/mixins/mixin';
import MoneyBackImg from '~images/mela-purchase/small-money-back.png';
import { getTrialEndDate } from '../../../../app/js/utils/web-helper';

const MoneyBackStripe = (props) => {
  return (
    <MoneyBackWidget {...props}>
      <Image src={MoneyBackImg} />
      <span>30 days Money back Guarantee</span>
      <InfoIcon iIconColor={props.iIconColor}>i</InfoIcon>
      <ToolTip bgColor={props.bgColor} textColor={props.textColor} toolTipColor={props.toolTipColor}>
        <p>If you’re not satisfied with SplashLearn within 30 days, i.e. till {getTrialEndDate(30)}, you can avail a full hassle free refund.</p>
      </ToolTip>
    </MoneyBackWidget>
  )
}
export const MoneyBackWidget = styled.div`
  background-color: ${props => props.bgColor};
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
  position: relative;
  margin: 2rem auto;
  height: 3rem;
  display: flex;
  width: 30rem;

  @media (min-width: ${breakpoints.lg}px){
    ${(props) => props.hideOnDesktop ? "display:none;" : ""}
  }

  @media (max-width: ${breakpoints.lg}px){
    ${(props) => props.hideTillTablet ? "display:none;" : ""}
  }

  @media ${device.PhoneLargeScreen} {
    width: 28.4rem;
  }
  @media ${device.Phone} {
    width: 28.4rem;
  }
  &:hover {
    div {
      display: block;
    }
  }
  img {
    position: absolute;
    width: 5rem;
    left: 0;
    top: -0.9rem;
    @media ${device.PhoneLargeScreen} {
      width: 4.3rem;
      top: -0.4rem;
    }
    @media ${device.Phone} {
      width: 4.3rem;
      top: -0.4rem;
    }
  }
  span {
    ${fontQuicksand(1.4, 1.8, 7)};
    color: ${props => props.fColor};
    margin-left: 1.5rem;
  }
`;
const ToolTip = styled.div`
  border: 0.2rem solid ${props => props.bgColor};
  box-sizing: border-box;
  background-color: ${props => props.toolTipColor || white};
  border-radius: 1rem;
  position: absolute;
  padding: 1.5rem;
  display: none;
  width: 37rem;
  z-index: 10;
  left: 0rem;
  top: 5rem;
  > P {
    ${fontQuicksand(1.2, 1.6, 5)};
    color: ${props => props.textColor ? titanWhite : codGrey};
    opacity: ${props => props.textColor ? 1 : 0.5};
  }
  &:after {
    content: ' ';
    position: absolute;
    border: 1.6rem solid;
    border-color: transparent transparent ${props => props.toolTipColor || white} transparent;
    top: -2.8rem;
    right: 7rem;
    border-radius: 0.5rem;
  }
  &:before {
    content: ' ';
    position: absolute;
    border: 1.6rem solid;
    border-color: transparent transparent ${props => props.bgColor} transparent;
    top: -3.2rem;
    right: 7rem;
    border-radius: 0.5rem;
  }
  @media ${device.PhoneLargeScreen} {
    width: 30.2rem;
    left: 0;
    &:after {
      right: 2rem;
      left: auto;
    }
    &:before {
      right: 2rem;
      left: auto;
    }
  }
  @media ${device.Phone} {
    width: 30.2rem;
    left: 0;
    &:after {
      right: 2rem;
      left: auto;
    }
    &:before {
      right: 2rem;
      left: auto;
    }
  }

  @media ${device.Tablet}{
    margin-top: 5px;
    left: 0;
    &:after {
      left: auto;
    }
    &:before {
      left: auto;
    }
  }
`;
const InfoIcon = styled.i`
  color: ${white};
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  width: 1.8rem;
  height: 1.8rem;
  ${fontQuicksand(1.8, 2.2, 7)};
  background: ${props => props.iIconColor};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 0 0.2rem 0 rgb(0 0 0 / 25%);
  @media ${device.PhoneLargeScreen} {
      width: 1.5rem;
      height: 1.5rem;
      ${fontQuicksand(1.4, 2.0, 7)};
    }
    @media ${device.Phone} {
      width: 1.5rem;
      height: 1.5rem;
      ${fontQuicksand(1.4, 2.0, 7)};
    }
`;

export default MoneyBackStripe;